export enum CodatCompanyRefreshRequestType {
    Customers = 'customers',
    Invoices = 'invoices',
}
